import JobApplicationContainer from "./JobApplicationContainer";

export default JobApplicationContainer;